import { ViewModel,View, ObservableArray } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { ServerConnection } from "src/server/serverConnection";
import { printTagSheetAction } from "../printTagSheetAction";
import  { WarehouseKeepingDetailView } from "./warehouseKeepingDetail-view"

export type Configuration = {
    canPrint : boolean;
    canCount : boolean;
    canConfirm : boolean;
}

export interface ITab{
    get title():string;
}

export class WarehouseKeepingDetailViewModel extends ViewModel implements IPopup{
    constructor(parentViewModel: ViewModel,configuration:Configuration) {
        super(parentViewModel);
        this._configuration = configuration;
        this.tabs = ObservableArray.create<ITab>();
        this.productsList = new ProductsList(this);
        this.firstCounting = new FirstCounting(this);
        this.secondCounting = new SecondCounting(this);
        this.thirdCounting = new ThirdCounting(this);
        this.finalConfirmation = new FinalConfirmation(this);
        this.tabs.push(this.productsList, this.firstCounting, this.secondCounting, this.thirdCounting, this.finalConfirmation);
        this.selectedTab = this.productsList;

    }
    closePopup() {    }
    GetDefaultView(): View <ViewModel> {
        return new WarehouseKeepingDetailView();
    }
    public getTypeId(): string {
        return "VM-30A9877A-EF0E-4EE1-8D84-3FEAA6546E10"
    }

    async loadById(warehouseKeepingId: string){
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/WarehouseKeepingServices/GetWarehouseKeepingData',{
                KeepingId:warehouseKeepingId
            });
            if(result.IsSuccessful==false){
                this.messageBoxConfirmWarning('خطا در برقراری ارتباط با سرور','خطا');
            }else{
                this.keepingId = result.KeepingId;
                this.warehouseName = result.WarehouseName;
                this.warehouseId = result.WarehouseId;
                this.status = result.Status;
                this.productsList.products.update(...result.MeasuredProductInfo.map((q,i) => {
                    let r = new SingleProduct(this.productsList);
                    r.index = i + 1;
                    r.id = q.Id;
                    r.name = q.Name;
                    r.code = q.Code;
                    r.balance = q.Balance;
                    r.accessibleBalance = q.AccessibleBalance;
                    return r;
                }));
                this.firstCounting.no = result.CountingList[0]?.No;
                this.firstCounting.isProductCountingsFinalized = this.status >= 2 ? true : false;
                this.firstCounting.productsCountedAmounts.update(...result.CountingList[0]?.Amounts?.map((q, i)=>{
                    let r = new FirstCountedAmount(this.firstCounting);
                    r.index = i + 1;
                    r.id = q.Id;
                    r.productName = this.productsList.products.filter(x => x.id == q.Id)[0].name;
                    r.tagNo = q.TagNo;
                    r.currentBalance = this.productsList.products.filter(x => x.id == q.Id)[0].balance;
                    r.newCountedAmount = q.Count;
                    r.isFinalized = this.firstCounting.isProductCountingsFinalized;
                    return r; 
                }));
                this.firstCounting.isProductCountingsTotallyRegistered = this.firstCounting.productsCountedAmounts.filter(x=>x.newCountedAmount).length == this.firstCounting.productsCountedAmounts.length ? true : false;
                this.secondCounting.no = result.CountingList[1]?.No;
                this.secondCounting.isProductCountingsFinalized = this.status >= 3 ? true : false;
                this.secondCounting.productsCountedAmounts.update(...result.CountingList[1]?.Amounts?.map((q, i)=>{
                    let r = new SecondCountedAmount(this.secondCounting);
                    r.index = i + 1;
                    r.id = q.Id;
                    r.productName = this.productsList.products.filter(x => x.id == q.Id)[0].name;
                    r.tagNo = q.TagNo;
                    r.currentBalance = this.productsList.products.filter(x => x.id == q.Id)[0].balance;
                    r.firstCountedAmount = this.firstCounting.productsCountedAmounts.filter(x=>x.id == q.Id)[0].newCountedAmount;
                    r.newCountedAmount = q.Count;
                    r.isFinalized = this.secondCounting.isProductCountingsFinalized;
                    return r; 
                }));
                this.secondCounting.isProductCountingsTotallyRegistered = this.secondCounting.productsCountedAmounts.filter(x=>x.newCountedAmount).length == this.secondCounting.productsCountedAmounts.length ? true : false;
                this.thirdCounting.no = result.CountingList[2]?.No;
                this.thirdCounting.isProductCountingsFinalized = this.status >= 4 ? true : false;
                this.thirdCounting.productsCountedAmounts.update(...result.CountingList[2]?.Amounts?.map((q, i)=>{
                    let r = new ThirdCountedAmount(this.thirdCounting);
                    r.index = i + 1;
                    r.id = q.Id;
                    r.productName = this.productsList.products.filter(x => x.id == q.Id)[0].name;
                    r.tagNo = q.TagNo;
                    r.currentBalance = this.productsList.products.filter(x => x.id == q.Id)[0].balance;
                    r.firstCountedAmount = this.firstCounting.productsCountedAmounts.filter(x=>x.id == q.Id)[0].newCountedAmount;
                    r.secondCountedAmount = this.secondCounting.productsCountedAmounts.filter(x=>x.id == q.Id)[0].newCountedAmount;
                    r.newCountedAmount = q.Count;
                    r.isFinalized = this.thirdCounting.isProductCountingsFinalized;
                    return r; 
                }));
                this.thirdCounting.isProductCountingsTotallyRegistered = this.thirdCounting.productsCountedAmounts.filter(x=>x.newCountedAmount).length == this.thirdCounting.productsCountedAmounts.length ? true : false;
                this.finalConfirmation.status = this.status;
                this.finalConfirmation.productCountings.update(...this.productsList.products.map(x=>{
                    let r = new ProductCountingStatus(this.finalConfirmation);
                    r.productCode = x.code;
                    r.productName = x.name;
                    r.currentBalance = x.balance;
                    r.firstCountedAmount = this.firstCounting.productsCountedAmounts.filter(y=>y.id == x.id)[0].newCountedAmount;
                    r.secondCountedAmount = this.secondCounting.productsCountedAmounts.filter(y=>y.id == x.id)[0].newCountedAmount;
                    r.thirdCountedAmount = this.thirdCounting.productsCountedAmounts.filter(y=>y.id == x.id)[0].newCountedAmount;
                    return r;
                }));
            }
        } catch (ex) {
            this.messageBoxConfirmWarning('خطا در برقراری ارتباط با سرور','خطا');
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

    private _configuration : Configuration;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set tabs(v: ObservableArray<ITab>) { this._tabs = v; } public get tabs(): ObservableArray<ITab> { return this._tabs;} private _tabs: ObservableArray<ITab>;
    public set selectedTab(v: ITab) { this._selectedTab = v; } public get selectedTab(): ITab { return this._selectedTab;} private _selectedTab: ITab;
    public set keepingId(v: string) { this._keepingId = v; } public get keepingId(): string { return this._keepingId;} private _keepingId: string;
    public set warehouseName(v: string) { this._warehouseName = v; } public get warehouseName(): string { return this._warehouseName;} private _warehouseName: string;
    public set warehouseId(v: string) { this._warehouseId = v; } public get warehouseId(): string { return this._warehouseId;} private _warehouseId: string;
    public set productsList(v: ProductsList) { this._productsList = v; } public get productsList(): ProductsList { return this._productsList;} private _productsList: ProductsList;
    public set firstCounting(v: FirstCounting) { this._firstCounting = v; } public get firstCounting(): FirstCounting { return this._firstCounting;} private _firstCounting: FirstCounting;
    public set secondCounting(v: SecondCounting) { this._secondCounting = v; } public get secondCounting(): SecondCounting { return this._secondCounting;} private _secondCounting: SecondCounting;
    public set thirdCounting(v: ThirdCounting) { this._thirdCounting = v; } public get thirdCounting(): ThirdCounting { return this._thirdCounting;} private _thirdCounting: ThirdCounting;
    public set finalConfirmation(v: FinalConfirmation) { this._finalConfirmation = v; } public get finalConfirmation(): FinalConfirmation { return this._finalConfirmation;} private _finalConfirmation: FinalConfirmation;
    public set status(v: number) { this._status = v; } public get status(): number { return this._status;} private _status: number;
    
}

export class ProductsList extends ViewModel implements ITab{
    public getTypeId(): string {return 'products-list';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:WarehouseKeepingDetailViewModel) {
        super(parent);
        this._typedParent = parent;
        this.products = ObservableArray.create<SingleProduct>();
        
    }
    get title(): string {
        return "لیست همه کالاها";
    }
    
    private _typedParent: WarehouseKeepingDetailViewModel;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set products(v: ObservableArray<SingleProduct>) { this._products = v; } public get products(): ObservableArray<SingleProduct> { return this._products;} private _products: ObservableArray<SingleProduct>;
    
    printTag(){
        let includedProducts = this.products.filter(x => x.isIncluded == true);
        let tagSpecs = ObservableArray.create<TagSheetSpecs>();
        includedProducts.forEach(element => {
            let specs = new TagSheetSpecs();
            specs.WarehouseName = this._typedParent.warehouseName;
            specs.ProductCode = element.code;
            specs.ProductName = element.name;
            specs.Unit = 'عدد';
            specs.Location = this._typedParent.warehouseName;
            specs.Year = new Date().toLocaleDateString('fa-IR').split('/')[0];
            specs.FirstCountedNumber = '';
            specs.FirstCountingPersonName = '';
            specs.FirstCountingDate = '';
            specs.FirstCounter = '';
            specs.FirstTagNumber = '';
            specs.SecondCountedNumber = '';
            specs.SecondCountingPersonName = '';
            specs.SecondCountingDate = '';
            specs.SecondCounter = '';
            specs.SecondTagNumber = '';
            specs.ThirdCountedNumber = '';
            specs.ThirdCountingPersonName = '';
            specs.ThirdCountingDate = '';
            specs.ThirdCounter = '';
            specs.ThirdTagNumber = '';
            tagSpecs.push(specs);
        });
        new printTagSheetAction().Print(this, tagSpecs);
    }
}

export class SingleProduct extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }

    public set index(v: number) { this._index = v; } public get index(): number { return this._index;} private _index: number;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set code(v: string) { this._code = v; } public get code(): string { return this._code;} private _code: string;
    public set balance(v: number) { this._balance = v; } public get balance(): number { return this._balance;} private _balance: number;
    public set accessibleBalance(v: number) { this._accessibleBalance = v; } public get accessibleBalance(): number { return this._accessibleBalance;} private _accessibleBalance: number;
    public set isIncluded(v: boolean) { this._isIncluded = v; } public get isIncluded(): boolean { return this._isIncluded;} private _isIncluded: boolean;
    
}

export class FirstCounting extends ViewModel implements ITab{
    public getTypeId(): string {return 'first-counting';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:WarehouseKeepingDetailViewModel) {
        super(parent);
        this._typedParent = parent;
        this.productsCountedAmounts = ObservableArray.create<FirstCountedAmount>();
    }
    get title(): string {
        return "شمارش اول";
    }
    
    private _typedParent: WarehouseKeepingDetailViewModel;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set no(v: number) { this._no = v; } public get no(): number { return this._no;} private _no: number;
    public set productsCountedAmounts(v: ObservableArray<FirstCountedAmount>) { this._productsCountedAmounts = v; } public get productsCountedAmounts(): ObservableArray<FirstCountedAmount> { return this._productsCountedAmounts;} private _productsCountedAmounts: ObservableArray<FirstCountedAmount>;
    public set isProductCountingsTotallyRegistered(v: boolean) { this._isProductCountingsTotallyRegistered = v; } public get isProductCountingsTotallyRegistered(): boolean { return this._isProductCountingsTotallyRegistered;} private _isProductCountingsTotallyRegistered: boolean;
    public set isProductCountingsFinalized(v: boolean) { this._isProductCountingsFinalized = v; } public get isProductCountingsFinalized(): boolean { return this._isProductCountingsFinalized;} private _isProductCountingsFinalized: boolean;
    
    async updateCountedNumber(){
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/WarehouseKeepingServices/UpdateCountedAmounts',{
                KeepingId:this._typedParent.keepingId,
                CountingNo:this.no,
                ProductAmounts:this.productsCountedAmounts.filter(y=>y.newCountedAmount).map(x=>{
                    return{
                        ProductId:x.id,
                        CountedAmount:x.newCountedAmount
                    };
                })
            });
            if(result.IsSuccessful){
                this.messageBoxConfirmSuccess('شمارش اول با موفقیت ثبت شد.','ثبت شمارش');
                this._typedParent.loadById(this._typedParent.keepingId);
            }
        } catch (ex) {
            console.log(ex);
            this.messageBoxConfirmWarning('خطا در برقراری ارتباط با سرور','خطا');
        } finally {
            this.isLoading = false;
        }
    }

    async confirm(){
        try {
            this.isLoading = true;
            if (this.isProductCountingsTotallyRegistered == false){
                this.messageBoxConfirmWarning('شمارش اول برای همه کالاها ثبت نشده است.','خطا');
            }
            else{
                try {
                    this.isLoading = true;
                    let result = await ServerConnection.callServer('/Complex/WarehouseKeepingServices/FinalizeFirstCountingForWarehouseKeepingData',{
                        KeepingId:this._typedParent.keepingId,
                    });
                    if (result.IsSuccessful){
                        this.messageBoxConfirmSuccess('شمارش اول با موفقیت نهایی شد.','ثبت شمارش');
                        this._typedParent.loadById(this._typedParent.keepingId);
                    }
                } catch (ex) {
                    console.log(ex);
                    this.messageBoxConfirmWarning('خطا در برقراری ارتباط با سرور','خطا');
                } finally {
                    this.isLoading = false;
                }
            }
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
}

export class FirstCountedAmount extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    
    public set index(v: number) { this._index = v; } public get index(): number { return this._index;} private _index: number;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set productName(v: string) { this._productName = v; } public get productName(): string { return this._productName;} private _productName: string;
    public set tagNo(v: string) { this._tagNo = v; } public get tagNo(): string { return this._tagNo;} private _tagNo: string;
    public set currentBalance(v: number) { this._currentBalance = v; } public get currentBalance(): number { return this._currentBalance;} private _currentBalance: number;
    public set newCountedAmount(v: number) { this._newCountedAmount = v; } public get newCountedAmount(): number { return this._newCountedAmount;} private _newCountedAmount: number;
    public set isFinalized(v: boolean) { this._isFinalized = v; } public get isFinalized(): boolean { return this._isFinalized;} private _isFinalized: boolean;
        
}

export class SecondCounting extends ViewModel implements ITab{
    public getTypeId(): string {return 'second-counting';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:WarehouseKeepingDetailViewModel) {
        super(parent);
        this._typedParent = parent;
        this.productsCountedAmounts = ObservableArray.create<SecondCountedAmount>();
    }
    get title(): string {
        return `شمارش دوم`;
    }
    
    private _typedParent: WarehouseKeepingDetailViewModel;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set no(v: number) { this._no = v; } public get no(): number { return this._no;} private _no: number;
    public set productsCountedAmounts(v: ObservableArray<SecondCountedAmount>) { this._productsCountedAmounts = v; } public get productsCountedAmounts(): ObservableArray<SecondCountedAmount> { return this._productsCountedAmounts;} private _productsCountedAmounts: ObservableArray<SecondCountedAmount>;
    public set isProductCountingsTotallyRegistered(v: boolean) { this._isProductCountingsTotallyRegistered = v; } public get isProductCountingsTotallyRegistered(): boolean { return this._isProductCountingsTotallyRegistered;} private _isProductCountingsTotallyRegistered: boolean;
    public set isProductCountingsFinalized(v: boolean) { this._isProductCountingsFinalized = v; } public get isProductCountingsFinalized(): boolean { return this._isProductCountingsFinalized;} private _isProductCountingsFinalized: boolean;

    async updateCountedNumber(){
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/WarehouseKeepingServices/UpdateCountedAmounts',{
                KeepingId:this._typedParent.keepingId,
                CountingNo:this.no,
                ProductAmounts:this.productsCountedAmounts.filter(y=>y.newCountedAmount).map(x=>{
                    return{
                        ProductId:x.id,
                        CountedAmount:x.newCountedAmount
                    };
                })
            });
            if(result.IsSuccessful){
                this.messageBoxConfirmSuccess('شمارش دوم با موفقیت ثبت شد.','ثبت شمارش');
                this._typedParent.loadById(this._typedParent.keepingId);
            }
        } catch (ex) {
            console.log(ex);
            this.messageBoxConfirmWarning('خطا در برقراری ارتباط با سرور','خطا');
        } finally {
            this.isLoading = false;
        }
    }

    async confirm(){
        try {
            this.isLoading = true;
            if (this.isProductCountingsTotallyRegistered == false){
                this.messageBoxConfirmWarning('شمارش دوم برای همه کالاها ثبت نشده است.','خطا');
            }
            else{
                try {
                    this.isLoading = true;
                    let result = await ServerConnection.callServer('/Complex/WarehouseKeepingServices/FinalizeSecondCountingForWarehouseKeepingData',{
                        KeepingId:this._typedParent.keepingId,
                    });
                    if (result.IsSuccessful){
                        this.messageBoxConfirmSuccess('شمارش دوم با موفقیت نهایی شد.','ثبت شمارش');
                        this._typedParent.loadById(this._typedParent.keepingId);
                    }
                } catch (ex) {
                    console.log(ex);
                    this.messageBoxConfirmWarning('خطا در برقراری ارتباط با سرور','خطا');
                } finally {
                    this.isLoading = false;
                }
            }
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
}

export class SecondCountedAmount extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    
    public set index(v: number) { this._index = v; } public get index(): number { return this._index;} private _index: number;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set productName(v: string) { this._productName = v; } public get productName(): string { return this._productName;} private _productName: string;
    public set tagNo(v: string) { this._tagNo = v; } public get tagNo(): string { return this._tagNo;} private _tagNo: string;
    public set currentBalance(v: number) { this._currentBalance = v; } public get currentBalance(): number { return this._currentBalance;} private _currentBalance: number;
    public set firstCountedAmount(v: number) { this._firstCountedAmount = v; } public get firstCountedAmount(): number { return this._firstCountedAmount;} private _firstCountedAmount: number;
    public set newCountedAmount(v: number) { this._newCountedAmount = v; } public get newCountedAmount(): number { return this._newCountedAmount;} private _newCountedAmount: number;
    public set isFinalized(v: boolean) { this._isFinalized = v; } public get isFinalized(): boolean { return this._isFinalized;} private _isFinalized: boolean;

}

export class ThirdCounting extends ViewModel implements ITab{
    public getTypeId(): string {return 'third-counting';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:WarehouseKeepingDetailViewModel) {
        super(parent);
        this._typedParent = parent;
        this.productsCountedAmounts = ObservableArray.create<ThirdCountedAmount>();
    }
    get title(): string {
        return `شمارش سوم`;
    }
    
    private _typedParent: WarehouseKeepingDetailViewModel;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set no(v: number) { this._no = v; } public get no(): number { return this._no;} private _no: number;
    public set productsCountedAmounts(v: ObservableArray<ThirdCountedAmount>) { this._productsCountedAmounts = v; } public get productsCountedAmounts(): ObservableArray<ThirdCountedAmount> { return this._productsCountedAmounts;} private _productsCountedAmounts: ObservableArray<ThirdCountedAmount>;
    public set isProductCountingsTotallyRegistered(v: boolean) { this._isProductCountingsTotallyRegistered = v; } public get isProductCountingsTotallyRegistered(): boolean { return this._isProductCountingsTotallyRegistered;} private _isProductCountingsTotallyRegistered: boolean;
    public set isProductCountingsFinalized(v: boolean) { this._isProductCountingsFinalized = v; } public get isProductCountingsFinalized(): boolean { return this._isProductCountingsFinalized;} private _isProductCountingsFinalized: boolean;
    
    async updateCountedNumber(){
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/WarehouseKeepingServices/UpdateCountedAmounts',{
                KeepingId:this._typedParent.keepingId,
                CountingNo:this.no,
                ProductAmounts:this.productsCountedAmounts.filter(y=>y.newCountedAmount).map(x=>{
                    return{
                        ProductId:x.id,
                        CountedAmount:x.newCountedAmount
                    };
                })
            });
            if(result.IsSuccessful){
                this.messageBoxConfirmSuccess('شمارش سوم با موفقیت ثبت شد.','ثبت شمارش');
                this._typedParent.loadById(this._typedParent.keepingId);
            }
        } catch (ex) {
            console.log(ex);
            this.messageBoxConfirmWarning('خطا در برقراری ارتباط با سرور','خطا');
        } finally {
            this.isLoading = false;
        }
    }

    async confirm(){
        try {
            this.isLoading = true;
            if (this.isProductCountingsTotallyRegistered == false){
                this.messageBoxConfirmWarning('شمارش سوم برای همه کالاها ثبت نشده است.','خطا');
            }
            else{
                try {
                    this.isLoading = true;
                    let result = await ServerConnection.callServer('/Complex/WarehouseKeepingServices/FinalizeThirdCountingForWarehouseKeepingData',{
                        KeepingId:this._typedParent.keepingId,
                    });
                    if (result.IsSuccessful){
                        this.messageBoxConfirmSuccess('شمارش سوم با موفقیت نهایی شد.','ثبت شمارش');
                        this._typedParent.loadById(this._typedParent.keepingId);
                    }
                } catch (ex) {
                    console.log(ex);
                    this.messageBoxConfirmWarning('خطا در برقراری ارتباط با سرور','خطا');
                } finally {
                    this.isLoading = false;
                }
            }
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
}

export class ThirdCountedAmount extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);

    }
    
    public set index(v: number) { this._index = v; } public get index(): number { return this._index;} private _index: number;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set productName(v: string) { this._productName = v; } public get productName(): string { return this._productName;} private _productName: string;
    public set tagNo(v: string) { this._tagNo = v; } public get tagNo(): string { return this._tagNo;} private _tagNo: string;
    public set currentBalance(v: number) { this._currentBalance = v; } public get currentBalance(): number { return this._currentBalance;} private _currentBalance: number;
    public set firstCountedAmount(v: number) { this._firstCountedAmount = v; } public get firstCountedAmount(): number { return this._firstCountedAmount;} private _firstCountedAmount: number;
    public set secondCountedAmount(v: number) { this._secondCountedAmount = v; } public get secondCountedAmount(): number { return this._secondCountedAmount;} private _secondCountedAmount: number;
    public set newCountedAmount(v: number) { this._newCountedAmount = v; } public get newCountedAmount(): number { return this._newCountedAmount;} private _newCountedAmount: number;
    public set isFinalized(v: boolean) { this._isFinalized = v; } public get isFinalized(): boolean { return this._isFinalized;} private _isFinalized: boolean;

}

export class TagSheetSpecs{
    public WarehouseName: string
    public ProductCode: string
    public ProductName: string
    public Unit: string
    public Location: string
    public Year: string
    public FirstCountedNumber: string
    public FirstCountingPersonName: string
    public FirstCountingDate: string
    public FirstCounter: string
    public FirstTagNumber: string
    public SecondCountedNumber: string
    public SecondCountingPersonName: string
    public SecondCountingDate: string
    public SecondCounter: string
    public SecondTagNumber: string
    public ThirdCountedNumber: string
    public ThirdCountingPersonName: string
    public ThirdCountingDate: string
    public ThirdCounter: string
    public ThirdTagNumber: string
} 

export class FinalConfirmation extends ViewModel implements ITab{
    public getTypeId(): string {return 'final-confirmation';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:WarehouseKeepingDetailViewModel) {
        super(parent);
        this._typedParent = parent;
        this.productCountings = ObservableArray.create<ProductCountingStatus>();
        
    }
    get title(): string {
        return "تایید نهایی";
    }

    private _typedParent: WarehouseKeepingDetailViewModel;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set productCountings(v: ObservableArray<ProductCountingStatus>) { this._productCountings = v; } public get productCountings(): ObservableArray<ProductCountingStatus> { return this._productCountings;} private _productCountings: ObservableArray<ProductCountingStatus>;
    public set status(v: number) { this._status = v; } public get status(): number { return this._status;} private _status: number;

    async confirm(){
        try {
            this.isLoading = true;
            if (this.status < 4){
                this.messageBoxConfirmWarning('شمارش های قبلی نهایی نشده اند.','خطا');
            }else if (this.status > 4){
                this.messageBoxConfirmWarning('تمامی شمارش های جاری پیش از این ثبت و نهایی شده اند.','خطا');
            }else{
                let result = await ServerConnection.callServer('/Complex/WarehouseKeepingServices/FinalizeAllCountingStagesForWarehouseKeeping',{
                    KeepingId:this._typedParent.keepingId,
                });
                if (result.IsSuccessful){
                    this.messageBoxConfirmSuccess('همه شمارش های جاری ثبت و نهایی شدند.','ثبت شمارش');
                    this._typedParent.loadById(this._typedParent.keepingId);
                }
            }
            
        } catch (ex) {
            console.log(ex);
            this.messageBoxConfirmWarning('خطا در برقراری ارتباط با سرور','خطا');
        } finally {
            this.isLoading = false;
        }
    }
    
}

export class ProductCountingStatus extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    
    public set productName(v: string) { this._productName = v; } public get productName(): string { return this._productName;} private _productName: string;
    public set productCode(v: string) { this._productCode = v; } public get productCode(): string { return this._productCode;} private _productCode: string;
    public set currentBalance(v: number) { this._currentBalance = v; } public get currentBalance(): number { return this._currentBalance;} private _currentBalance: number;
    public set firstCountedAmount(v: number) { this._firstCountedAmount = v; } public get firstCountedAmount(): number { return this._firstCountedAmount;} private _firstCountedAmount: number;
    public set secondCountedAmount(v: number) { this._secondCountedAmount = v; } public get secondCountedAmount(): number { return this._secondCountedAmount;} private _secondCountedAmount: number;
    public set thirdCountedAmount(v: number) { this._thirdCountedAmount = v; } public get thirdCountedAmount(): number { return this._thirdCountedAmount;} private _thirdCountedAmount: number;
}
